module.exports = __webpack_public_path__ + "static/ver2/img/logo_short.ecbf5111.png";